import { render } from "./ModuleList.vue?vue&type=template&id=b014d3b4&scoped=true"
import script from "./ModuleList.vue?vue&type=script&lang=js"
export * from "./ModuleList.vue?vue&type=script&lang=js"

import "./ModuleList.vue?vue&type=style&index=0&id=b014d3b4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b014d3b4"]])

export default __exports__